module.exports = __webpack_public_path__ + "media/succeed.25a038ba.mp3";